import type { HasWeapons } from '../HasWeapons'
import type { Entity } from './index'

export default function hasAtLeastOneWeapon(entity: Entity): entity is Entity & HasWeapons {
  return ((entity as HasWeapons)?.weapons?.length as number) > 0
}
